import { render, staticRenderFns } from "./thirdPartyManagement.vue?vue&type=template&id=65298627&scoped=true&"
import script from "./thirdPartyManagement.vue?vue&type=script&lang=js&"
export * from "./thirdPartyManagement.vue?vue&type=script&lang=js&"
import style0 from "./thirdPartyManagement.vue?vue&type=style&index=0&id=65298627&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65298627",
  null
  
)

export default component.exports